module.exports = __webpack_public_path__ + "static/media/INVEA_How_to_apply.048c4bfb.jpg";